<div id="app" [class.terminal-mode]="terminalMode()">
  <p-toast position="bottom-right"></p-toast>

  @if (showNavigation || authInitialized) {
    <!-- Hero Section -->
    <section class="hero">
      @if (terminalMode()) {
        <app-terminal-hero-background />
      } @else {
        <app-brand-hero-background />
      }
      <div class="hero-header">
        <div class="hero-logo">
          <img src="./assets/logo/acit-secondary.png" alt="AC-IT Platform" />
          <span class="hero-logo-text">AC-IT <span class="hero-logo-separator">|</span> 4CEE AI Platform</span>
        </div>
        <div class="hero-user">
          @if (terminalMode()) {
            <span class="terminal-badge">
              <span class="terminal-badge-dot"></span>
              TERMINAL MODE
            </span>
          }
          <span class="hero-welcome">{{ greeting }}, <span class="hero-name">{{ displayName }}</span></span>
          <div class="env-switcher">
            <button class="env-badge" [style.--env-color]="currentEnvironment.color" (click)="toggleEnvSwitcher()">
              <span class="env-dot"></span>
              <span>{{ currentEnvironment.label }}</span>
              <mat-icon class="env-chevron">expand_more</mat-icon>
            </button>
            @if (showEnvSwitcher) {
              <div class="env-dropdown">
                @for (env of environments; track env.name) {
                  <button
                    class="env-option"
                    [class.env-option-active]="env.name === currentEnv"
                    (click)="switchEnvironment(env)">
                    <span class="env-dot" [style.--env-color]="env.color"></span>
                    <span>{{ env.label }}</span>
                  </button>
                }
              </div>
            }
          </div>
          @if (terminalMode()) {
            <button class="hero-logout" (click)="exitTerminalMode()">
              <mat-icon>power_settings_new</mat-icon>
              <span>Exit Terminal</span>
            </button>
          }
          <button class="hero-logout" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>
        </div>
      </div>
      <div class="hero-tiles">
        <div class="tiles-grid">
          @for (tile of tiles; track tile.path) {
            <div class="tile" (click)="openTile(tile)" [style.--tile-color]="tile.color">
              <div class="tile-icon-wrapper">
                <mat-icon class="tile-icon">{{ tile.icon }}</mat-icon>
              </div>
              <div class="tile-body">
                <h3 class="tile-title">{{ tile.title }}</h3>
                <p class="tile-description">{{ tile.description }}</p>
              </div>
              <div class="tile-arrow">
                <mat-icon>arrow_forward</mat-icon>
              </div>
            </div>
          } @empty {
            <div class="empty-state">
              <mat-icon class="empty-state-icon">lock</mat-icon>
              <h3 class="empty-state-title">No applications available</h3>
              <p class="empty-state-description">You currently don't have access to any applications. Please contact your administrator to request access.</p>
            </div>
          }
        </div>
      </div>
    </section>

    <!-- Content Section -->
    <main class="main-content">
      <section class="content-section">
        <h2 class="section-title">External Links</h2>
        <div class="tiles-grid">
          @for (link of externalLinks; track link.title) {
            <a
              class="tile"
              [class.tile-disabled]="!link.url"
              [style.--tile-color]="link.color"
              [attr.href]="link.url ? link.url : null"
              target="_blank"
              rel="noopener noreferrer"
              (click)="openExternalLink(link, $event)">
              <div class="tile-icon-wrapper">
                <mat-icon class="tile-icon">{{ link.icon }}</mat-icon>
              </div>
              <div class="tile-body">
                <h3 class="tile-title">{{ link.title }}</h3>
                <p class="tile-description">{{ link.description }}</p>
              </div>
              <div class="tile-arrow">
                <mat-icon>open_in_new</mat-icon>
              </div>
            </a>
          }
        </div>
      </section>

      <!-- Footer Actions (temporarily hidden, not removed) -->
      @if (false) {
        <div class="footer-actions">
          <button class="footer-button" disabled>
            <mat-icon>lightbulb</mat-icon>
            <span>Feature Request</span>
          </button>
          <button class="footer-button" disabled>
            <mat-icon>bug_report</mat-icon>
            <span>Bug Report</span>
          </button>
          <button class="footer-button footer-button-right" disabled>
            <mat-icon>support_agent</mat-icon>
            <span>Contact Support</span>
          </button>
        </div>
      }
    </main>
  }

  @if (loading) {
    <div class="loading-overlay" role="status" aria-label="Loading">
      <div class="loading-container">
        <img src="./assets/logo/acit.png" alt="" class="loading-logo" />
        <div class="loading-dots" aria-hidden="true">
          <span class="dot dot-1"></span>
          <span class="dot dot-2"></span>
          <span class="dot dot-3"></span>
        </div>
      </div>
    </div>
  }

  @if (terminalMode() && showSnakeGame()) {
    <app-snake-game (close)="showSnakeGame.set(false)" />
  }

  @if (!terminalMode() && showWordleGame()) {
    <app-wordle-game (close)="showWordleGame.set(false)" />
  }

  @if (terminalMode() && showPongGame()) {
    <app-pong-game (close)="showPongGame.set(false)" />
  }

  @if (terminalMode() && showPacmanGame()) {
    <app-pacman-game (close)="showPacmanGame.set(false)" />
  }

  @if (terminalMode() && showDoomGame()) {
    <app-doom-game (close)="showDoomGame.set(false)" />
  }

  @if (terminalMode() && showBreakoutGame()) {
    <app-breakout-game (close)="showBreakoutGame.set(false)" />
  }

  @if (terminalMode() && showAsteroidsGame()) {
    <app-asteroids-game (close)="showAsteroidsGame.set(false)" />
  }

  @if (terminalMode() && showInvadersGame()) {
    <app-invaders-game (close)="showInvadersGame.set(false)" />
  }

  @if (terminalMode() && showGalagaGame()) {
    <app-galaga-game (close)="showGalagaGame.set(false)" />
  }

  @if (terminalMode() && showTetrisGame()) {
    <app-tetris-game (close)="showTetrisGame.set(false)" />
  }
</div>
